import { IonSearchbar } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { setSearchText } from "../../../store/users";
import { selectSearchText } from "../../../store/users/selectors/selectSearchText";

export const UsersSearchBar = () => {
  const dispatch = useDispatch();
  const searchText = useSelector(selectSearchText);
  return (
    <>
      <IonSearchbar
        value={searchText}
        placeholder="Buscar usuario"
        onIonChange={(e) => dispatch(setSearchText(e.detail.value || ""))}
      />
    </>
  );
};
